import FutbolPage from './FutbolPage'

export default FutbolPage


// WEBPACK FOOTER //
// ./src/app/catalogo/futbol/index.js